import createErrorType from 'app/utils/createErrorType';

interface INavigationErrorInit {
 readonly url: string;
 readonly method: string;
 readonly cause: Error,
}

/**
 * Error type meant to be used when manipulating History API failed.
 */
export default class NavigationError extends createErrorType('NavigationError') {
  public static readonly NAME = 'NavigationError';

  public readonly url: string;
  public readonly method: string;
  public readonly cause: Error;

  /**
   * @param {Object} args
   * @param {string} args.url - address that we were unable to
   * navigate to
   * @param {string} args.method - method that we were using, for
   * example PUSH, POP or REPLACE
   * @param {?Error} args.cause - original error that was thrown
   */
  public constructor({ url, method, cause }: INavigationErrorInit) {
    super();

    this.url = url;
    this.method = method;
    this.cause = cause;

    this.message = `Can't navigate to ${url}. Cause: ${cause.message}`;
  }

  public toJSON() {
    return {
      name:    this.name,
      message: this.message,
      url:     this.url,
      method:  this.method,
      cause:   this.cause,
      stack:   this.stack,
    };
  }
}
